<template>
  <main role="main" class="py-4">
    <b-container>
      <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 class="m-0">{{ $t("errorStat") }}</h4>

        <!-- <div>
          <b-button variant="outline-secondary" @click="onClickReloadBtn">
            <b-icon icon="arrow-clockwise"></b-icon> {{ $t("reload") }}
          </b-button>
          <b-button  variant="outline-primary" class="ml-4" :disabled="!totalItems" @click="onClickExportToExcel">
            <b-icon-download class="mr-2"></b-icon-download> {{ $t("export") }}
          </b-button>
        </div> -->
      </div>

      <b-form class="d-flex flex-row align-items-center mb-3" @submit.prevent="onClickSearchBtn">
        <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
        <b-form-select class="mr-2" :options="filterCoreType" v-model="coreType" @change="coreChange"/>
        </div>
        <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
        <b-form-select class="mr-2" :options="filterCorePlanType" v-model="corePlanType" />
        </div>
        <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
          <div class="flex-shrink-0 mr-3"> {{ $t("fromDate") }}</div>
          <b-form-datepicker v-model="startDate" value-as-date required
                             :max="endDate ? endDate: new Date()"
                             no-flip hide-header
                             label-no-date-selected="DD/MM/YYYY"
                             locale="vi"
                             :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                             start-weekday="1"></b-form-datepicker>
        </div>
        <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
          <div class="flex-shrink-0 mr-3">{{ $t("toDate") }}</div>
          <b-form-datepicker v-model="endDate" value-as-date required
                             :min= "startDate ? startDate: new Date()"
                             no-flip hide-header
                             label-no-date-selected="DD/MM/YYYY"
                             locale="vi"
                             :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                             start-weekday="1"></b-form-datepicker>
        </div>
        <b-button type="submit" variant="primary">{{ $t("apply") }}</b-button>
      </b-form>
      <div  v-if=dtChart class="chart-wrapper">
        <v-chart class="chart" style="font-family: sans-serif !important;" :option="option"/>
      </div>

      <b-table  v-if=corePlanType ref="table" :items="tableItemProvider" hover primary-key="id" :fields="tableFields" :busy="isLoading" show-empty
               :per-page="itemsPerPage" :current-page="currentPage">
        <template v-slot:table-busy>
          <div class="text-center text-secondary py-4">{{ $t("loadingData") }}</div>
        </template>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
        <template v-slot:cell(os)="data">
          {{ data.item.platform.os }}
        </template>
        <template v-slot:cell(device)="data">
          {{ data.item.platform.type }}
        </template>
        <template v-slot:cell(browser)="data">
          {{ data.item.platform.software }}
        </template>
      </b-table>
      <div class="d-flex flex-row align-items-center justify-content-between">
        <div></div>
        <!-- <b-button variant="link" :disabled="!totalItems || isExportingToExcel" @click="onClickExportToExcel">
          <b-icon-download class="mr-2"></b-icon-download> {{ $t("export") }}
        </b-button> -->
        <div class="d-flex flex-row align-items-center">
          <div v-if="totalItems" class="text-right flex-shrink-0 mr-3">{{ $t("resultCount", { count: totalItems }) }}</div>
          <b-pagination class="my-0 mr-3" v-model="currentPage" :total-rows="totalItems" :per-page="itemsPerPage"></b-pagination>
          <b-form-select v-model="itemsPerPage" :options="itemsPerPageSelections"></b-form-select>
        </div>
      </div>
    </b-container>
  </main>
</template>

<style lang="scss" scoped>
.chart-wrapper {
  width: 98vw;
  height: 500px;
  aspect-ratio: 4/1;
  display: block;
  position: relative;
  justify-self: center;
  font-family: sans-serif !important;
  margin-top:32px
}
</style>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator';
import _ from "lodash";
import moment from "moment";
import BaseComponent from "@/components/BaseComponent";
import { BvTableFieldArray } from "bootstrap-vue";
import { BTable, BvTableCtxObject, BvTableProviderPromiseResult } from "bootstrap-vue/src/components/table";
import * as reportService from "@/service/reportService";
import * as subscriptionPlanService from "@/service/subscriptionPlanService";

@Component
export default class ErrorStat extends BaseComponent {

  startDate: Date = new Date();
  endDate: Date = new Date();
  formErrorMsg = "";
  isLoading = false;

  @Ref("table") table: BTable;
  tableFields: BvTableFieldArray = [
    {
      key: "index",
      label: this.$t("STT").toString(),
      thClass: "text-nowrap",
    },
    {
      key: "content",
      label: this.$t("contentError").toString(),
      thClass: "text-nowrap",
    },
    {
      key: "count",
      label: this.$t("count").toString(),
      thClass: "text-nowrap",
    },
    {
      key: "device",
      label: this.$t("device").toString(),
      thClass: "text-nowrap",
    },
    {
      key: "os",
      label: this.$t("os").toString(),
      thClass: "text-nowrap",
    },
    {
      key: "browser",
      label: this.$t("browser").toString(),
      thClass: "text-nowrap",
    }
  ];

  option = {
    title: [
      {
        text: this.$t('chartLogTitle').toString(),
        left: 'center',
        fontWeight: 'bold',
        textStyle: {
          fontFamily: 'sans-serif'
        }
      },
      {
        subtext: this.$t('chartSub1').toString(),
        left: '12.5%',
        top: '50%',
        textAlign: 'center',
        subtextStyle: {
          fontWeight: 'bold',
          fontSize: 15,
          fontFamily: 'sans-serif' 
        }
      },
      {
        subtext: this.$t('chartSub2').toString(),
        left: '37.5%',
        top: '50%',
        textAlign: 'center',
        subtextStyle: {
          fontWeight: 'bold',
          fontSize: 15,
          fontFamily: 'sans-serif' 
        }
      },
      {
        subtext: this.$t('chartSub3').toString(),
        left: '62.5%',
        top: '50%',
        textAlign: 'center',
        subtextStyle: {
          fontWeight: 'bold',
          fontSize: 15,
          fontFamily: 'sans-serif' 
        }
      },
      {
        subtext: this.$t('chartSub4').toString(),
        left: '87.5%',
        top: '50%',
        textAlign: 'center',
        subtextStyle: {
          fontWeight: 'bold',
          fontSize: 15,
          fontFamily: 'sans-serif' 
        }
      },

    ],
    legend: {
      bottom: 80,
      left: 'center',
      orient: 'horizontal',
    },
    tooltip: {
      formatter: '{b} : {c} ({d}%)'
    },
    series: [
      {
        type: 'pie',
        radius: '25%',
        center: ['12.5%', '35%'],
        data: [],
        label: {
          formatter: '{b} : {c} ({d}%) ',
          fontSize: 10,
        },
      },
      {
        type: 'pie',
        radius: '25%',
        center: ['37.5%', '35%'],
        data: [],
        label: {
          formatter: ' {b}: {c} ({d}%)  ',
          backgroundColor: '#F6F8FC',
          borderColor: '#8C8D8E',
          borderRadius: 4,
          fontSize: 10,
        },
      },
      {
        type: 'pie',
        radius: '25%',
        center: ['62.5%', '35%'],
        data: [],
        label: {
          formatter: ' {b}: {c} ({d}%)  ',
          backgroundColor: '#F6F8FC',
          borderColor: '#8C8D8E',
          borderRadius: 4,
          fontSize: 10,
        },
      }
      ,
      {
        type: 'pie',
        radius: '25%',
        center: ['87.5%', '35%'],
        data: [],
        label: {
          formatter: ' {b}: {c} ({d}%)  ',
          backgroundColor: '#F6F8FC',
          borderColor: '#8C8D8E',
          borderRadius: 4,
          fontSize: 10,
        },
      }
    ]
  };

  dtChart = null;

  itemsPerPageSelections = [
    { value: 20, text: "20 " + this.$t("itemsPerPage").toString() },
    { value: 50, text: "50 " + this.$t("itemsPerPage").toString() },
    { value: 100, text: "100 " + this.$t("itemsPerPage").toString() },
    { value: 200, text: "200 " + this.$t("itemsPerPage").toString() },
  ];
  itemsPerPage = 20;
  currentPage = 1;
  totalItems = 0;
  coreType: string = '';
  corePlanType: string = '';
  listCorePlan = [];
  filterCoreType = [];
  filterCorePlanType = [];

  async beforeMount() {
    this.filterCoreType = await subscriptionPlanService.getPlanTypeList();
    this.coreType = this.filterCoreType[0].value;
    this.listCorePlan = await subscriptionPlanService.getCorePlanTypeList({ type: this.coreType });
    this.filterCorePlanType = this.listCorePlan.map(cp => {
      let url = new URL(cp.apiUrl);
      return {
        value: url.hostname,
        text: url.hostname,
      };
    });
    this.corePlanType = this.filterCorePlanType[0].value;
    this.dataChart();
  }

  async mounted() {
    this.startDate = moment().subtract(1, "days").startOf("day").toDate();
    this.endDate = moment().endOf("day").toDate();
  }

  async coreChange(checked) {
    this.listCorePlan = await subscriptionPlanService.getCorePlanTypeList({ type: this.coreType });
    this.filterCorePlanType = this.listCorePlan.map(cp => {
      let url = new URL(cp.apiUrl);
      return {
        value: url.hostname,
        text: url.hostname,
      };
    });
    this.corePlanType = this.filterCorePlanType[0].value;
  }

  onClickReloadBtn() {
    this.startDate = moment().subtract(1, "days").startOf("day").toDate();
    this.endDate = moment().endOf("day").toDate();
    this.formErrorMsg = "";
    this.itemsPerPage = 20;
    this.currentPage = 1;
    this.totalItems = 0;

    this.table.refresh();
    this.dataChart();
  }

  onClickSearchBtn() {
    this.table.refresh();
    this.dataChart();
  }

  async dataChart() {
    try {
      this.dtChart = await reportService.getstatsGeneral(
        this.coreType, this.corePlanType, this.startDate.toISOString(), this.endDate.toISOString(),
      );
      let detail = this.dtChart.details;
      //data all
      this.option.series[0].data = [];
      this.option.series[1].data = [];
      this.option.series[2].data = [];
      this.option.series[3].data = [];
      let seriesNum = 0;
      detail.forEach(device => {
        let numAll = 0;
        if (device.deviceType == 'DESKTOP') {
          seriesNum = 1;
        }
        else {
          seriesNum = 3;
        }
        device.statics.forEach(os => {
          let numDevice = 0;
          os.browsers.forEach(br => {
            numAll = numAll + br.count;
            numDevice = numDevice + br.count;
            if (device.deviceType == 'DESKTOP') {
              if (this.option.series[2].data.filter(item => { return item.name == br.name; }).length > 0) {
                let objIndex = this.option.series[2].data.findIndex(
                  (temp) => {
                    if (temp['name'] == br.name) { console.log(temp['name']); }
                    return temp['name'] == br.name;
                  }
                );
                this.option.series[2].data[objIndex].value = this.option.series[2].data[objIndex].value + br.count;
              }
              else {
                this.option.series[2].data.push({
                  value: br.count,
                  name: br.name
                });
              }
            }
          });
          this.option.series[seriesNum].data.push({
            value: numDevice,
            name: os.os
          });
        });
        this.option.series[0].data.push({
          value: numAll,
          name: device.deviceType,
        });
      });

    } catch (e) {
      this.toastError(e);
      return [];
    }
  }

  async tableItemProvider(ctx: BvTableCtxObject): Promise<BvTableProviderPromiseResult> {
    try {
      const customerListRes = await reportService.getErrorListDetails(
        this.coreType, this.corePlanType, this.startDate.toISOString(), this.endDate.toISOString(),
        ctx.currentPage,
        this.itemsPerPage
      );

      this.totalItems = customerListRes.total;
      return customerListRes.details;

    } catch (e) {
      this.toastError(e);
      return [];
    }
  }

  onClickExportToExcel() {
    return;
  }
}
</script>
